import script from "./PrivatePlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatePlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PrivatePlanDetailsPopup.vue?vue&type=style&index=0&id=a46a39ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a46a39ec"]])

export default __exports__